import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueAgile from "vue-agile";

import VueWaypoint from "vue-waypoint";
import VueScrollTo from "vue-scrollto";
import VueYoutube from "vue-youtube";
import Icon from "../node_modules/vue-awesome/components/Icon.vue";

import "vue-awesome/icons/chevron-up";
import "vue-awesome/icons/chevron-down";
import "vue-awesome/icons/chevron-right";
import "vue-awesome/icons/chevron-left";
import "vue-awesome/icons/play";

import "vue-awesome/icons/brands/facebook-f";
import "vue-awesome/icons/brands/instagram";

Vue.use(VueWaypoint);
Vue.use(VueScrollTo);
Vue.use(VueAgile);
Vue.use(VueYoutube);
Vue.component("v-icon", Icon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
